module.exports = __webpack_public_path__ + "img/Luma.f6f5cafd.png";